// Getters para obtener los filtros y convenios guardados en el store BDC
export default {
  getFilters: state => state.bdc.filtros,
  getCategorias: state => state.bdc.filtros.categorias,
  getMerchants: state => state.bdc.filtros.merchants,
  getTipoProductos: state => state.bdc.filtros.tipoProductos,
  getConvenios: state => state.bdc.convenios.data,
  getTotalPaginas: state => state.bdc.convenios.paginas,
  getTotalRegistros: state => state.bdc.convenios.registros
};
